export const env = { configuration: 'tasteadvisor-stg', platform: 'web' };